import { render, staticRenderFns } from "./SitchAddress.vue?vue&type=template&id=65a663ef&scoped=true&"
import script from "./SitchAddress.vue?vue&type=script&lang=ts&"
export * from "./SitchAddress.vue?vue&type=script&lang=ts&"
import style0 from "./SitchAddress.vue?vue&type=style&index=0&id=65a663ef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a663ef",
  null
  
)

export default component.exports